enum Theme {
    LIGHT = '',
    DARK = 'dark:',
}
export default Theme;